import { forwardRef } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { ImpactReportData } from 'store/impactReport/types';
import { CURRENT_CYCLE_YEAR } from 'screens/Profile/utils';
import { getSummaryStats } from './summaryStats';

interface Props {
  firstName?: string;
  impactReportData: ImpactReportData;
}

// Static copy of the final slide's summary, sized 9:16 and captured as the share image.
// No animation or Lottie: the capture has to look the same every time.
export const ShareCard = forwardRef<HTMLDivElement, Props>(
  ({ firstName, impactReportData }, ref) => (
    <div ref={ref} className="impact-share-card">
      <div className="impact-share-card-title" data-dd-privacy="mask">
        <span>{firstName ? `${firstName}’s` : 'My'}</span>
        <span>{`${CURRENT_CYCLE_YEAR} Impact`}</span>
        <span>Report</span>
      </div>
      <div className="impact-share-card-powered-by">
        <span>Powered by</span>
        {/* The dark-text lockup needs a light backing on the blue gradient. */}
        <span className="impact-share-card-logo-chip">
          {/* html-to-image re-fetches this with CORS. A URL of its own keeps the header's cached
              no-CORS copy of the same file out of that fetch. */}
          <img
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/oath_logos/Oath_FullLockup_Color_DarkText.svg?share-card`}
            crossOrigin="anonymous"
            alt="Oath logo"
          />
        </span>
      </div>
      <dl className="impact-share-card-stats">
        {getSummaryStats(impactReportData).map(stat => (
          <div key={stat.label} className="impact-share-card-stat">
            <dt>{stat.label}</dt>
            <dd>{stat.value}</dd>
          </div>
        ))}
      </dl>
      <div className="impact-share-card-footer">Give smarter @oath.vote</div>
    </div>
  )
);

ShareCard.displayName = 'ShareCard';
